import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FloorPlanModel } from '../models/floor-plan.model';
import { FloorPlanService } from '../services/floor-plan.service';

@Injectable()
export class FloorPlansResolver implements Resolve<Array<FloorPlanModel>> {

    constructor(private service: FloorPlanService) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<FloorPlanModel>> {
        return this.service.GetFloorPlans();
    }
}
